import { Controller } from '@hotwired/stimulus';

// Generic roving-focus helper: moves real browser focus between visible,
// enabled `item` targets on Up/Down. Compose with other controllers (e.g.
// `filter`) on the same element and bind the keydown actions on whichever
// element should capture them (usually the shared wrapper, so it also
// catches keys pressed while a search input inside it has focus). Once an
// item is focused, activating it (e.g. Enter on a button) is native.
export default class extends Controller {
  static targets = ['item'];

  next(event) {
    event.preventDefault();
    this.focusRelative(1);
  }

  previous(event) {
    event.preventDefault();
    this.focusRelative(-1);
  }

  // Optional: bind to mouseenter on each item so hovering one with the
  // mouse keeps real focus in sync with what the pointer is over.
  hover(event) {
    event.currentTarget.focus();
  }

  focusRelative(step) {
    const items = this.itemTargets.filter((el) => !el.disabled && !el.classList.contains('hidden'));
    if (!items.length) return;

    const currentIndex = items.indexOf(document.activeElement);
    const nextIndex =
      currentIndex === -1
        ? step > 0
          ? 0
          : items.length - 1
        : (currentIndex + step + items.length) % items.length;

    items[nextIndex].focus();
  }
}
